module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "clientcontainer",
    staticClass: "client-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6,
      "align": "left"
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editCol
    }
  }, [_vm._v("设置显示列")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "left"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "placeholder": "请选择区域"
    },
    on: {
      "change": _vm.areaFilter
    },
    model: {
      value: (_vm.sortAreaId),
      callback: function($$v) {
        _vm.sortAreaId = $$v
      },
      expression: "sortAreaId"
    }
  }, _vm._l((_vm.allAreaDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.areaname,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "right"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "clearable": "",
      "type": "date",
      "placeholder": "注册时间起",
      "picker-options": _vm.startPickerOptions
    },
    on: {
      "change": _vm.createTimeChange
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "left"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "clearable": "",
      "type": "date",
      "placeholder": "注册时间止",
      "picker-options": _vm.endPickerOptions
    },
    on: {
      "change": _vm.createTimeChange
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "right"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择启用、禁用状态"
    },
    on: {
      "change": _vm.areaFilter
    },
    model: {
      value: (_vm.statusKey),
      callback: function($$v) {
        _vm.statusKey = $$v
      },
      expression: "statusKey"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "right"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "快速搜索"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.vagueContent),
      callback: function($$v) {
        _vm.vagueContent = $$v
      },
      expression: "vagueContent"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "right"
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downloadTemplate
    }
  }, [_vm._v("下载导入模板")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "center"
    }
  }, [_c('a', {
    staticClass: "file importFile",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("导入Excel\n\t\t\t\t\t\t"), _c('input', {
    attrs: {
      "id": "file",
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    on: {
      "change": function($event) {
        return _vm.importExcel($event)
      }
    }
  })])])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": ""
    }
  }, [_c('af-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), (_vm.colUnShowKeys.indexOf('code') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "code",
      "label": "客户编码",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('reallyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "reallyname",
      "label": "客户姓名",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('areaname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "areaname",
      "label": "所属团队",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('aagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "aagencyname",
      "label": "培训公司",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('pagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "pagencyname",
      "label": "销售公司",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('cagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "cagencyname",
      "label": "代理1",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('tagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "tagencyname",
      "label": "代理2",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('province') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "province",
      "label": "省",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('city') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "city",
      "label": "市",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('district') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "district",
      "label": "县（区）",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('address') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "address",
      "label": "详细地址",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('linkphone') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "linkphone",
      "label": "联系电话",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('agencyrole') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "agencyrole",
      "label": "代理级别",
      "formatter": _vm.formatAgencyRole,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('status') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "status",
      "label": " 状态 ",
      "formatter": _vm.formatStatus,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('creattime') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "creattime",
      "label": "注册时间",
      "formatter": _vm.formatCreatTime,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('af-table-column', {
    key: Math.random(),
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.role === 1 || (scope.row.status !== 0 && scope.row.status !== 1)) ? _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (_vm.role === 1 || (scope.row.status !== 0 && scope.row.status !== 1)) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s((scope.row.status === 1 || scope.row.status === 2 ? '启用' : '禁用')))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": "设置显示列",
      "visible": _vm.colDialogVisible,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.colDialogVisible = $event
      },
      "close": _vm.closeColSet
    }
  }, [_c('el-transfer', {
    staticStyle: {
      "width": "500px",
      "margin": "15px auto"
    },
    attrs: {
      "data": _vm.colDatas,
      "titles": ['显示列', '不显示列']
    },
    model: {
      value: (_vm.colUnShowKeys),
      callback: function($$v) {
        _vm.colUnShowKeys = $$v
      },
      expression: "colUnShowKeys"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px",
      "height": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户编码",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.codeDisabled
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", $$v)
      },
      expression: "formData.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户姓名",
      "prop": "reallyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.reallyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "reallyname", $$v)
      },
      expression: "formData.reallyname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属团队",
      "prop": "areaid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.areaid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "areaid", $$v)
      },
      expression: "formData.areaid"
    }
  }, _vm._l((_vm.areaDatas), function(item) {
    return _c('el-option', {
      key: item.areaId,
      attrs: {
        "label": item.areaName,
        "value": item.areaId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理级别",
      "prop": "agencyrole"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.roleChange
    },
    model: {
      value: (_vm.formData.agencyrole),
      callback: function($$v) {
        _vm.$set(_vm.formData, "agencyrole", $$v)
      },
      expression: "formData.agencyrole"
    }
  }, _vm._l((_vm.agencyRoleOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agencyShow),
      expression: "agencyShow"
    }],
    attrs: {
      "label": "培训公司",
      "prop": "aagencyid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.aagencyid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "aagencyid", $$v)
      },
      expression: "formData.aagencyid"
    }
  }, _vm._l((_vm.agencyDatas), function(item) {
    return _c('el-option', {
      key: item.aagencyid,
      attrs: {
        "label": item.aagencyname,
        "value": item.aagencyid
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pagencyShow),
      expression: "pagencyShow"
    }],
    attrs: {
      "label": "销售公司",
      "prop": "pagencyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.pagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pagencyname", $$v)
      },
      expression: "formData.pagencyname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cagencyShow),
      expression: "cagencyShow"
    }],
    attrs: {
      "label": "代 理 1",
      "prop": "cagencyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.cagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cagencyname", $$v)
      },
      expression: "formData.cagencyname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tagencyShow),
      expression: "tagencyShow"
    }],
    attrs: {
      "label": "代 理 2",
      "prop": "tagencyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.tagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tagencyname", $$v)
      },
      expression: "formData.tagencyname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "linkphone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.linkphone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "linkphone", $$v)
      },
      expression: "formData.linkphone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省市县(区)",
      "prop": ""
    }
  }, [_c('region-picker', {
    attrs: {
      "placeholder": {
        province: '选择省份',
        city: '选择市',
        district: '选择县（区）'
      },
      "province": _vm.formData.region.province,
      "city": _vm.formData.region.city,
      "district": _vm.formData.region.district
    },
    on: {
      "onchange": _vm.regionChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-105f491e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/clientManagement/Client.vue
// module id = 698
// module chunks = 1